import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { DataGridItem } from "components/data-grid";
import { FormattedMessage, injectIntl } from "react-intl";
import styles from "./styles/layout-timing-form.css.js";
import withStyles from "components/with-styles";
import { RadioGroup, RadioButton } from "components/form/form-radiobutton";
import { sendToArray, sendToMap } from "pages/graphicset/utils";
import { DEFAULT_DURATION } from "components/timeline";
import uniqueId from "lodash/uniqueId";
import FormHelperText from "@material-ui/core/FormHelperText";

const LayoutSendtoForm = ({ graphicsetSchedules, disabled, layoutPath, layout, handleChange, intl, classes }) => {
  const isFirst = useRef(true);
  const sendToPath = `${layoutPath}.sendTo`;

  const handleRadioChange = event => {
    if (event.target.value != layout.sendTo) {
      handleChange(sendToPath)(event.target.value);

      if (sendToMap.banner === event.target.value && (!layout.segments || layout.segments.length <= 0)) {
        handleChange(`${layoutPath}.segments`)(
          graphicsetSchedules.map(schedule => ({
            id: uniqueId(),
            type: schedule.type,
            start: 0,
            end: DEFAULT_DURATION,
          })),
        );
      }
    } else {
      handleChange(sendToPath)(sendToMap.gallery);
    }
  };

  useEffect(
    () => {
      if (disabled && !isFirst.current) {
        handleChange(sendToPath)(sendToMap.gallery);
      }
      isFirst.current = false;
    },
    [disabled, handleChange, sendToPath],
  );

  return (
    <>
      <DataGridItem big>
        <FormHelperText>
          <FormattedMessage id="graphicset.use.warning" />
        </FormHelperText>
      </DataGridItem>
      <DataGridItem big>
        <RadioGroup
          style={{ display: "flex" }}
          name={sendToPath}
          selectedValue={layout.sendTo}
          label={intl.formatMessage({ id: "graphicset.layout.sendTo" })}
        >
          {sendToArray
            .filter(element => element != sendToMap.gallery)
            .map(sendToElement => (
              <RadioButton
                disabled={disabled}
                key={sendToElement}
                name={sendToPath}
                value={sendToElement}
                onClick={handleRadioChange}
                label={intl.formatMessage({ id: `graphicset.layout.sendTo.in.${sendToElement.toLowerCase()}` })}
              />
            ))}
        </RadioGroup>
      </DataGridItem>
    </>
  );
};

LayoutSendtoForm.propTypes = {
  /**
   * Path del layout en los datos
   */
  layoutPath: PropTypes.string,
  /**
   * Función que se invoca al modificar algún valor
   */
  handleChange: PropTypes.func,
  /**
   * Objeto con los valores que se quieren representar
   */
  layout: PropTypes.object,
  /**
   * Indica si el formulario está deshabilitado, por defecto envía el valor Gallery
   */
  disabled: PropTypes.bool,
  /**
   * Schedules del graphicset
   */
  graphicsetSchedules: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      period: PropTypes.number.isRequired,
    }),
  ),
};

export default withStyles(styles)(injectIntl(LayoutSendtoForm));
